export default __webpack_public_path__ + "static/media/json.ee2fbfe0.svg";